var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDigits = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none",
    viewBox: "0 0 20 21",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.273 4.244v9.863h-2.38V6.469h-.056L2.63 7.817v-2.06l2.432-1.513z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4CBB17",
    d: "M14.339 10.85a3.26 3.26 0 1 0 0 6.521 3.26 3.26 0 0 0 0-6.52m1.553 4.912a.39.39 0 0 1-.388.389h-2.332a.39.39 0 0 1-.388-.389v-1.943a.39.39 0 0 1 .388-.388h.195v-.389a.971.971 0 1 1 1.942 0v.39h.195c.213 0 .388.174.388.387zm-1.553-3.322a.603.603 0 0 0-.603.602v.39h1.205v-.39a.603.603 0 0 0-.602-.602m0 1.962a.39.39 0 0 0-.39.389.389.389 0 1 0 .389-.389",
    className: "lock"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.636 5.533q-.455-.672-1.284-1.048-.828-.375-1.95-.375c-.748 0-1.362.132-1.91.397q-.82.397-1.273 1.13t-.453 1.738h2.259q0-.448.171-.76.17-.315.479-.48t.717-.166q.408 0 .718.159.314.159.491.45.179.292.178.7 0 .367-.149.677-.15.31-.434.617-.283.305-.688.672l-3.598 3.15v1.714h1.407l-.001-.131a4.72 4.72 0 0 1 4.88-4.712q.471-.573.668-1.057.227-.553.227-1.117 0-.885-.455-1.558"
  })));
};
export default SvgDigits;